<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import './css/slick.css'
import './css/bootstrap.css'
import './css/jquery.mmenu.all.css'
import './css/style.css'
import './css/timeline/timeline.css'
import './css/timeline/timeline.min.css'
// import  "./css/css/animate.css"
import './font-awesome-4.5.0/css/font-awesome.min.css'
import $ from 'jquery'
export default {
  data () {
    return {}
  },
  computed: {
    // locale () {
    //   return this.$i18n.getLocaleMessage(this.$store.getters.lang).antLocale
    // }
  },
  mounted () {
    var nowTime = this.DateFormat()
    // 2.设置南京事件公祭日
    // eslint-disable-next-line camelcase
    var NJ_country_startTime = '08-31 00:00:00'
    // eslint-disable-next-line camelcase
    var NJ_country_overTime = '08-30 00:00:00'
    // 2.设置汶川哀悼开始及结束 是 5月12号凌晨
    // eslint-disable-next-line camelcase
    var earthquake_startTime = '08-31 00:00:00'
    // eslint-disable-next-line camelcase
    var earthquake_overTime = '08-30 00:00:00'
    // 3.将变灰封装到一个函数里，需要的时候再调用
    this.grey()
    // 在这判断时间，时间字符串可以直接判断大小，不过要精确到秒
    // eslint-disable-next-line camelcase
    if (nowTime >= NJ_country_startTime && nowTime <= NJ_country_overTime) {
      // 4.把html 设置灰色滤镜
      this.grey()
    // eslint-disable-next-line camelcase
    } else if (nowTime >= earthquake_startTime && nowTime <= earthquake_overTime) {
      // 4.把html 设置灰色滤镜
      this.grey()
    }
  },
  methods: {
    // 1.得到当前的时间（时间戳）
    DateFormat () {
      const date = new Date()
      let currentDate
      let currentTime
      const seperator = '-' // 如果想要其他格式 只需 修改这里
      let month = date.getMonth() + 1
      let day = date.getDate()
      const hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      const minute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      const second = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      // eslint-disable-next-line no-unused-expressions
      month >= 1 && month <= 9 ? (month = '0' + month) : ''
      // eslint-disable-next-line no-unused-expressions
      day >= 0 && day <= 9 ? (day = '0' + day) : ''
      // 当前 日期
      // eslint-disable-next-line prefer-const
      currentDate = month + seperator + day
      // 当前 时间
      // eslint-disable-next-line prefer-const
      currentTime = hour + ':' + minute + ':' + second
      // 输出格式 为 8-27 14:45:33
      return currentDate + ' ' + currentTime
    },
    grey () {
      console.log('进入')
      $('html').css({
        // '-webkit-filter': 'grayscale(100%)',
        // '-moz-filter': 'grayscale(100%)',
        // '-ms-filter': 'grayscale(100%)',
        // '-o-filter': 'grayscale(100%)',
        // // ie滤镜
        // filter: 'progid:DXImageTransform.Microsoft.BasicImage(grayscale=1)',
        // // ie6 等低版本浏览器不需要加滤镜
        // _filter: 'none'
      })
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color:black;
}
</style>



// WEBPACK FOOTER //
// src/App.vue